import { Route, Routes } from "react-router-dom";
import AdminShell from "../../components/admin/AdminShell";
import { Guard } from "../../components/admin/PageHeader";
import Dashboard from "./Dashboard";
import UserManagement from "./UserManagement";
import ProfileDetail from "./ProfileDetail";
import AddProfile from "./AddProfile";
import ProfileApproval from "./ProfileApproval";
import PhotoReview from "./PhotoReview";
import MatchesShares from "./MatchesShares";
import ComingSoon from "./ComingSoon";
import IncompleteRegistrations from "./IncompleteRegistrations";
import IncompleteDetail from "./IncompleteDetail";
import ReportsFlags from "./ReportsFlags";

const g = (perm, el) => <Guard perm={perm}>{el}</Guard>;

export default function AdminApp() {
  return (
    <Routes>
      <Route element={<AdminShell />}>
        <Route index element={g(null, <Dashboard />)} />
        <Route path="profiles" element={g(null, <UserManagement />)} />
        <Route path="profiles/brides" element={g(null, <UserManagement profileFor="bride" />)} />
        <Route path="profiles/grooms" element={g(null, <UserManagement profileFor="groom" />)} />
        <Route path="profiles/incomplete" element={g(null, <IncompleteRegistrations />)} />
        <Route path="incomplete/:userId" element={g(null, <IncompleteDetail />)} />
        <Route path="profiles/new" element={g("can_edit", <AddProfile />)} />
        <Route path="profiles/:id" element={g(null, <ProfileDetail />)} />
        <Route path="approvals" element={g("can_approve", <ProfileApproval />)} />
        <Route path="media" element={g(["can_approve", "can_verify"], <PhotoReview />)} />
        <Route path="matches" element={g("can_share", <MatchesShares />)} />
        <Route path="reports" element={g(null, <ReportsFlags />)} />
        <Route path="settings" element={g("admin", <ComingSoon title="Settings" />)} />
        <Route path="*" element={<ComingSoon title="Page not found" />} />
      </Route>
    </Routes>
  );
}
